import { useEffect } from "react";
import { Row, Col, Form, Input, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  fetchJobPortalJobList,
  resetJobPortalJobList,
  fetchJobPortalWorkLocations,
  setSearchValues,
  setPageNumber,
} from "../../../store/job/action";
import FilterButton from "./FilterButton";
import "./SearchBar.scss";

export default function SearchBar({ jobId }) {
  const dispatch = useDispatch();

  // Get global state variables from Redux store
  const search = useSelector((state) => state.JobPortalJobReducer.search);

  // Set Search Values
  useEffect(() => {
    const name = "keyword";
    try {
      if (jobId) {
        dispatch(setSearchValues(name, jobId))
          .then(() => dispatch(resetJobPortalJobList()))
          .then(() => dispatch(fetchJobPortalJobList(0)))
          .then(() => dispatch(fetchJobPortalWorkLocations()));
      }
    } catch (e) {
      console.error("Error occurred while getting job ID from URL:", e);
    }
  }, [jobId]);

  // Update the search state when the user types in the input fields
  function handleSearchChange(e) {
    const { name, value } = e.target;
    dispatch(setSearchValues(name, value));
  }

  // Handle search submit
  function handleFindSubmit(e) {
    e.preventDefault();
    dispatch(setPageNumber(0))
      .then(() => dispatch(resetJobPortalJobList()))
      .then(() => dispatch(fetchJobPortalJobList(0)))
      .then(() => dispatch(fetchJobPortalWorkLocations()));
  }

  return (
    <Form
      className="mt-5 mb-3 bg-white rounded shadow-sm searchbar-container"
      spellCheck="false"
      onSubmit={handleFindSubmit}
    >
      <Row className="m-0">
        <Col
          className="d-flex flex-grow-1 align-items-center px-4 py-2 border-end border-end-none"
          xs="12"
          md="auto"
        >
          <i
            className="las la-search rotate-270 color-trueblue"
            style={{ fontSize: "1.5rem" }}
          />
          <Input
            name="keyword"
            className="border-0"
            type="text"
            placeholder="Search by: Job Title or Job ID"
            value={search.keyword}
            onChange={handleSearchChange}
          />
        </Col>
        <Col
          className="d-flex flex-grow-1 align-items-center ps-4 py-2"
          xs="12"
          md="auto"
        >
          <i
            className="las la-map-marker color-trueblue"
            style={{ fontSize: "1.5rem" }}
          />
          <Input
            name="country"
            className="border-0"
            type="text"
            placeholder="Country, City or States"
            value={search.country}
            onChange={handleSearchChange}
          />
          <div className="d-flex">
            <FilterButton />
            <Button className="text-nowrap bg-trueblue" type="submit">
              Find Job
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  );
}
